import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'

const home = () => import('@/pages/home')
const appointSuccess = () => import('@/pages/appointment-success')
const appointSuccess2 = () => import('@/pages/appointment-success2')
const componentNotFound = () => import('@/pages/404')
const audition = () => import('@/pages/audition')

Vue.use(Router)

// const router = new Router

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: App,
      children: [
        {
          path: '',
          component: componentNotFound
        },
        {
          path: '/test',
          component: home
        },
        {
          path: '/appointment-success',
          name: 'appointment-success',
          component: appointSuccess
        },
        {
          path: '/appointment-success2',
          name: 'appointment-success2',
          component: appointSuccess2
        },
        {
          path: '/audition',
          name: 'audition',
          component: audition
        },
        {
          path: '/error',
          name: 'error',
          component: () => import('@/pages/error')
        }
      ]
    },
    {
      path: '*',
      component: componentNotFound
    }
  ]
})
